import { useMemo, useCallback } from 'react';

const REPORT_TYPES = {
  MONTHLY: 'mensual',
  BIANNUAL: 'semestral', 
  ANNUAL: 'anual'
};

const MONTH_NAMES = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

export const usePeriodLogic = () => {
  const currentDate = useMemo(() => ({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  }), []);

  const getPeriodOptions = useCallback((type, year) => {
    if (!type || !year) return [];
    
    const isCurrentYear = parseInt(year) === currentDate.year;
    
    switch (type) {
      case REPORT_TYPES.MONTHLY:
        const totalMonths = isCurrentYear ? currentDate.month : 12;
        return Array.from({ length: totalMonths }, (_, i) => ({
          label: MONTH_NAMES[i],
          value: i + 1,
        }));
      
      case REPORT_TYPES.BIANNUAL:
        const semesters = [{ label: "1° Semestre", value: 1 }];
        if (!isCurrentYear || currentDate.month >= 7) {
          semesters.push({ label: "2° Semestre", value: 2 });
        }
        return semesters;
      
      case REPORT_TYPES.ANNUAL:
        return [{ label: "Anual", value: "full" }];
      
      default:
        return [];
    }
  }, [currentDate]);

  const getApiPeriodName = useCallback((type, periodValue) => {
    switch (type) {
      case REPORT_TYPES.MONTHLY:
        return MONTH_NAMES[parseInt(periodValue) - 1] || periodValue;
      case REPORT_TYPES.BIANNUAL:
        return periodValue === "1" || periodValue === 1 ? "Semestre 1" : "Semestre 2";
      case REPORT_TYPES.ANNUAL:
        return "Anual";
      default:
        return periodValue;
    }
  }, []);

  return {
    REPORT_TYPES,
    currentDate,
    getPeriodOptions,
    getApiPeriodName
  };
};
export default usePeriodLogic;